<template>
    <div class="neirong">
        <img src="@/assets/u1026.png">
    </div>
</template>

<script>

export default {
    name: 'HomePage',
    components: {

    },
    props: {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.neirong {
    text-align: center;
    padding-top: 250px;
}
</style>
